import { Modal } from 'common';
import { navigateBack } from 'navigation';
import { ProductContext, ProductLarge } from 'product';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import './style.scss';
function ProductModal() {
    var _a;
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const productModalRef = useRef(null);
    const parentProductContext = (_a = location.state) === null || _a === void 0 ? void 0 : _a.parentContext;
    const closeModal = () => {
        navigateBack(dispatch, history, location);
    };
    useEffect(() => {
        var _a;
        (_a = productModalRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location]);
    return (React.createElement(Modal, { className: "product-modal__wrapper", onClose: closeModal, showCloseButton: false, labelId: "product-content-title" },
        React.createElement(ProductContext.Provider, { value: { context: 'ProductModal', parentContext: parentProductContext } },
            React.createElement("div", { className: "product-modal", ref: productModalRef },
                React.createElement(ProductLarge, { handleClose: closeModal })))));
}
export default ProductModal;
